import { toast } from 'react-hot-toast'

import { Button } from 'mmfintech-portal-commons'
import { QRCodeSVG } from 'qrcode.react'
import { QrCodeWrapper } from './PreviewPix.styled'

import { copyTextToClipboard, tr } from 'mmfintech-commons'

import PixLogo from '../../../assets/icons/pix-logo.svg'

export const PreviewPix = ({ value }) => (
  <QrCodeWrapper>
    <p className='text-center'>
      <img src={PixLogo} alt='' />
    </p>

    <p className='text-center'>
      {tr(
        'CHECKOUT.DEPOSIT.RESULT.QR_CODE',
        'Open the app with your registered PIX key, choose Pay with Pix and scan the QR Code or copy and paste the code.'
      )}
    </p>

    <p className='text-center code'>
      <QRCodeSVG value={value} size={256} />
    </p>

    <p className='text-center'>
      <Button
        type='button'
        text={tr('CHECKOUT.DEPOSIT.RESULT.COPY_CODE', 'Copy code')}
        onClick={() => {
          copyTextToClipboard(value)
          toast.remove()
          toast.success(tr('CHECKOUT.DEPOSIT.RESULT.QR_CODE_COPIED', 'Code is copied to clipboard').toString())
        }}
      />
    </p>
  </QrCodeWrapper>
)
